import { useContext } from "react";
import { OnboardingExpertiseLevelContext } from "../context/onboarding-expertise-level-context";
export var useOnboardingExpertiseLevel = function () {
  return useContext(OnboardingExpertiseLevelContext) || {};
};